import React from 'react'
import { TextContent } from '../../../common/textContent'
import { SectionHeader, Spacing } from '@rse/uikit'
import { InputText } from '../components/InputText'

export const PreApprovalTargetPayment = () => {
  return (
    <section>
      <Spacing value={28} />
      <SectionHeader>
        <TextContent
          resourceKey="app-wizard.title-maximum-downpayment"
          defaultValue="What is the maximum that you are prepared to put down for a downpayment?"
        />
      </SectionHeader>
      <Spacing value={14} />
      <InputText id="maxDownpayment" label="$ *" type="number" />
    </section>
  )
}
